import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { connect } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { formatDateToUTCString } from "./../../../utilities/dateConversion";
import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  IconButton,
  Chip,
  Tooltip,
  Modal
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { Alert } from "reactstrap";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import spinner from "../../../assets/images/loadingGif.gif";

import {
  getOrgBilling,
  deleteOrgBilling,
  createOrgBilling,
  clearAllOrgBillingMessages,
  updateOrgBilling,
} from "../../../store/organizationBilling/organizationBillingSlice";
import UpdateOrganizationBilling from "./UpdateOrganizationBilling";
import OrganizationBillingUsage from "./OrganizationBillingUsage";
import { clearAllOrgBillingUsageMessages } from "../../../store/organizationBillingUsage/organizationBillingUsageSlice";

import { makeStyles } from "@mui/styles";
import { commonStyles } from '../../../theme';
import { modalStyles } from '../../../styles/commonStyles';

const useStyles = makeStyles((theme) => ({
  ...commonStyles,
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  deleteModal: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    padding: "20px",
    border: "1px solid #ccc",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
    maxHeight: "80vh",
    overflowY: "auto",
  },

  modalButtons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  ...modalStyles,
}));

const OrganizationBilling = (props) => {
  console.log("OrganizationAccount props: ", props);
  const { orgCode } = useParams();
  const location = useLocation();
  const { orgName } = location.state || {};

  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [updateBillingId, setUpdateBillingId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [orgBillingToDelete, setOrgBillingToDelete] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [orgBillingToAdd, setOrgBillingToAdd] = useState(null);

  const [showApproveModal, setShowApproveMOdal] = useState(false);
  const [orgBillingToApprove, setOrgBillingToApprove] = useState(null);

  const [billingUsageModalOpen, setBillingUsageModalOpen] = useState(false);

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setOrgBillingToDelete(null);
  };

  const handleDeleteConfirm = () => {
    if (orgBillingToDelete) {
      props.deleteOrgBilling({
        billingId: orgBillingToDelete?.billingId,
        // orgcode: orgCode,
        accountNumber: orgBillingToDelete?.accountNumber,
        customerIdentifier: orgBillingToDelete?.customerIdentifier,
      });
      closeDeleteModal();
    }
  };

  const openDeleteModal = (args) => {
    setOrgBillingToDelete(args);
    setShowDeleteModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setOrgBillingToAdd(null);
  };

  const handleAddConfirm = () => {
    if (orgBillingToAdd) {
      props.createOrgBilling({
        billingId: orgBillingToAdd?.billingId,
        accountNumber: orgBillingToAdd?.accountNumber,
        customerIdentifier: orgBillingToAdd?.customerIdentifier,
      });
    }
  };

  const openAddModal = (args) => {
    setOrgBillingToAdd(args);
    setShowAddModal(true);
  };

  // Approve modal
  const closeApproveModal = () => {
    setShowApproveMOdal(false);
    setOrgBillingToApprove(null);
  };

  const handleApproveConfirm = () => {
    if (orgBillingToApprove) {
      console.log(
        "🚀 ~ handleApproveConfirm ~ updateBillingId:",
        orgBillingToApprove
      );

      let payload = {
        billingId: orgBillingToApprove.billingId,
        accountNumber: orgBillingToApprove.accountNumber,
        customerIdentifier: orgBillingToApprove.customerIdentifier,
        dateFrom: orgBillingToApprove.dateFrom,
        dateTo: orgBillingToApprove.dateTo,
        proratedDays: "" + orgBillingToApprove.proratedDays,
        cloudSpend: "" + orgBillingToApprove.cloudSpend,
        usageAmount: "" + orgBillingToApprove.usageAmount,
        subscriptionType: orgBillingToApprove.subscriptionType,
        contractAmount: "" + orgBillingToApprove.contractAmount,
        additionalAmount: "" + orgBillingToApprove.additionalAmount,
        thresholdAmount: "" + orgBillingToApprove.thresholdAmount,
        totalAmount: "" + orgBillingToApprove.totalAmount,
        isApproved: true,
        isDeleted: orgBillingToApprove.isDeleted,
        usagePercentage: "" + orgBillingToApprove.usagePercentage,
      };

      console.log("🚀 ~ handleApproveConfirm ~ payload:", payload);

      props.updateOrgBilling(payload);
    }
  };

  const openApproveModal = (args) => {
    setOrgBillingToApprove(args);
    setShowApproveMOdal(true);
  };

  const handleBillingUsage = (orgCode, orgName) => {
    console.log("Billing Usage Clicked :: ", orgCode);
    setBillingUsageModalOpen(true);
  };

  const handleBillingUsageModalClose = () => {
    console.log("handleBillingUsageModalClose :: ");
    setBillingUsageModalOpen(false);
  };

  const appBarStyles = {
    backgroundColor: "whitesmoke",
    // Add more custom styles as needed
  };
  const classes = useStyles();

  const getOrgBilling = useCallback(() => {
    props.getOrgBilling(orgCode);
  }, [props, orgCode]);

  const clearAllOrgBillingMessages = useCallback(() => {
    props.clearAllOrgBillingMessages(orgCode);
    props.clearAllOrgBillingUsageMessages(orgCode);
  }, [props, orgCode]);

  const orgBilling = useMemo(() => props.orgBilling, [props]);

  useEffect(() => {
    getOrgBilling(orgCode);
  }, [orgCode]);

  //For displaying message for getting organization billing
  let createBillingUsageSuccess = props.createOrgBillingUsageMessage;
  let createBillingUsageError = props.createOrgBillingUsageError;
  useEffect(() => {
    console.log("createBillingUsageSuccess = " + createBillingUsageSuccess);
    if (createBillingUsageSuccess || createBillingUsageError) {
      console.log(
        "Inside if, createOrgBillingUsageMessage = " + createBillingUsageSuccess
      );
      getOrgBilling(orgCode);
      setTimeout(() => {
        clearAllOrgBillingUsageMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    createBillingUsageSuccess,
    createBillingUsageError,
    clearAllOrgBillingUsageMessages,
  ]);

  //For displaying message for getting organization billing
  let getOrgBillingMsg = props.getOrgBillingMessage;
  let getOrgBillingErr = props.getOrgBillingError;
  useEffect(() => {
    console.log("getOrgBillingMsg = " + getOrgBillingMsg);
    if (getOrgBillingMsg || getOrgBillingErr) {
      console.log("Inside if, getOrgBillingMsg = " + getOrgBillingMsg);
      setTimeout(() => {
        clearAllOrgBillingMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getOrgBillingMsg, getOrgBillingErr, clearAllOrgBillingMessages]);

  //For displaying message for updating organization
  let updateOrgBillingMsg = props.updateOrgBillingMessage;
  let updateOrgBillingErr = props.updateOrgBillingError;
  useEffect(() => {
    console.log("updateOrgBillingMsg = " + updateOrgBillingMsg);
    if (updateOrgBillingMsg) {
      console.log("Inside if, updateOrgBillingMsg = " + updateOrgBillingMsg);
      getOrgBilling(orgCode);
      //Close Modal
      setUpdateDialogOpen(false);
      closeApproveModal(false);
      setTimeout(() => {
        clearAllOrgBillingMessages();
      }, 10000); // Hide all messages after 10 seconds
    } else if (updateOrgBillingErr) {
      console.log("Inside if, updateOrgBillingErr = " + updateOrgBillingErr);
      setTimeout(() => {
        clearAllOrgBillingMessages();
      }, 10000);
    }
  }, [updateOrgBillingMsg, updateOrgBillingErr]);

  //For displaying message for delete org Billing
  let deleteOrgBillingMsg = props.deleteOrgBillingMessage;
  useEffect(() => {
    console.log("deleteOrgBillingMsg = " + deleteOrgBillingMsg);
    if (deleteOrgBillingMsg) {
      console.log("Inside if, deleteOrgBillingMsg = " + deleteOrgBillingMsg);
      getOrgBilling(orgCode);
      setTimeout(() => {
        props.clearAllOrgBillingMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [deleteOrgBillingMsg]);

  //For displaying message for delete org Billing
  let createOrgBillingMsg = props.createOrgBillingMessage;
  let createOrgBillingErr = props.createOrgBillingError;
  useEffect(() => {
    console.log("createOrgBillingMsg = " + createOrgBillingMsg);
    if (createOrgBillingMsg) {
      console.log("Inside if, createOrgBillingMsg = " + createOrgBillingMsg);
      closeAddModal();
      getOrgBilling(orgCode);
      setTimeout(() => {
        props.clearAllOrgBillingMessages();
      }, 10000); // Hide all messages after 10 seconds
    } else if (createOrgBillingErr) {
      console.log("Inside if, createOrgBillingErr = " + createOrgBillingMsg);
      setTimeout(() => {
        props.clearAllOrgBillingMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [createOrgBillingMsg, createOrgBillingErr]);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    dateFrom: true,
    dateTo: true,
    accountNumber: true,
    subscriptionType: true,
    contractAmount: false,
    proratedDays: false,
    thresholdAmount: false,
    cloudSpend: true,
    usagePercentage: true,
    overage_amount: true,
    usageAmount: true,
    additionalAmount: true,
    totalAmount: true,
    isCalculated: true,
    isApproved: true,
    isBilled: true,
    createdDate: false,
    accCreatedDate: false,
    accExpirationDate: false,
    customerIdentifier: false,
    offerId: false,
    agreementId: false,
    createdBy: false,
    lastModifiedBy: false,
    lastModifiedDate: false,
    approvedBy: false,
    approvedDate: false,
    deletedBy: false,
    deletedDate: false,
    isDeleted: false,
  });

  const columns = [
    { field: "dateFrom", headerName: "From Date", width: 150 },
    { field: "dateTo", headerName: "To Date", width: 150 },
    { field: "accountNumber", headerName: "Account Number", width: 150 },
    { field: "subscriptionType", headerName: "Subscription Type", width: 150 },
    { field: "contractAmount", headerName: "Contract Amount ($)", width: 150 },
    { field: "proratedDays", headerName: "Prorated Days", width: 150 },

    { field: "cloudSpend", headerName: "Cloud Spend ($)", width: 150 },
    { field: "usagePercentage", headerName: "Overage Percentage (%)", width: 180 },
    { field: "overage_amount", headerName: "Overage Amount ($)", width: 180 },
    { field: "usageAmount", headerName: "Usage Amount ($)", width: 150 },
    { field: "thresholdAmount", headerName: "Threshold Amount ($)", width: 150 },
    { field: "additionalAmount", headerName: "Compliance Charge ($)", width: 180 },

    { field: "totalAmount", headerName: "Total Amount ($)", width: 150 },
    { field: "isCalculated", headerName: "Calculated?", width: 150 },
    { field: "isApproved", headerName: "Approved?", width: 150 },
    { field: "isBilled", headerName: "Billed?", width: 150 },
    { field: "createdDate", headerName: "Creation Date", width: 150 },
    {
      field: "accCreatedDate",
      headerName: "Account Creation Date",
      width: 150,
    },
    {
      field: "accExpirationDate",
      headerName: "Account Expiration Date",
      width: 150,
    },
    {
      field: "customerIdentifier",
      headerName: "Customer Identifier",
      width: 150,
    },
    { field: "offerId", headerName: "Offer Id", width: 150 },
    { field: "agreementId", headerName: "Agreement Id", width: 150 },

    { field: "createdBy", headerName: "Created By", width: 150 },

    { field: "lastModifiedBy", headerName: "Last Modified By", width: 150 },
    {
      field: "lastModifiedDate",
      headerName: "Last Modification Date",
      width: 150,
    },
    { field: "approvedBy", headerName: "Approved By", width: 150 },
    { field: "approvedDate", headerName: "Approved Date", width: 150 },
    { field: "deletedBy", headerName: "Deleted By", width: 150 },
    { field: "deletedDate", headerName: "Deletion Date", width: 150 },

    { field: "isDeleted", headerName: "Deleted?", width: 150 },

    {
      field: "add",

      headerName: "",

      width: 100,
      renderCell: (params) => (
        <Tooltip title="POST bill to AWS" arrow>
          <Button
            variant="contained"
            color="primary"
            disabled={params.row.isDeleted || params.row.isBilled || !params.row.isApproved}
            onClick={() => {
              openAddModal(params.row);
            }}
          >
            POST
          </Button>
        </Tooltip>
      ),
    },
    {
      field: "approve",
      headerName: "",
      width: 100,
      renderCell: (params) => (
        <Tooltip title="Approve Billing Record" arrow>
          <Button
            variant="contained"
            color="primary"
            disabled={params.row.isApproved || params.row.isDeleted || params.row.isBilled}
            onClick={() => {
              console.log("Approve org billing: ", params.row);
              setOrgBillingToApprove(params.row?.billingId);
              openApproveModal(params.row);
            }}
          >
            Approve
          </Button>
        </Tooltip>
      ),
    },
    {
      field: "edit",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <Tooltip title="Edit Org Billing" arrow>
          <IconButton
            variant="contained"
            color="primary"
            disabled={params.row.isDeleted || params.row.isBilled}
            onClick={() => {
              console.log("update org billing: ", params.row);
              setUpdateBillingId(params.row?.billingId);
              setUpdateDialogOpen(true);
            }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      field: "delete",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <Tooltip title="Delete Org Billing" arrow>
          <IconButton
            color="secondary"
            disabled={params.row.isDeleted || params.row.isBilled}
            onClick={() => {
              console.log("delete org billing: ", params.row);
              openDeleteModal(params.row);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <SnackbarProvider />
      <AppBar position="static" style={appBarStyles}>
        <Toolbar>
          <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
            <Link component={RouterLink} to="/organization" color="inherit">
              <HomeOutlinedIcon />
            </Link>
            <Typography color="textPrimary">
              <Link component={RouterLink} to="/organization" color="inherit">
                Organization{" "}
              </Link>
              / <span id="viewId">Billing</span>
            </Typography>
            {orgName && <Chip label={orgName} color="primary" />}
          </Breadcrumbs>
        </Toolbar>
      </AppBar>
      <h1>Organization Billing</h1>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleIcon />}
        onClick={() => {
          handleBillingUsage(orgCode, orgName);
        }}
      >
        Create Billing Usage Record
      </Button>
      {/* Status Messages */}
      {(props.isGettingOrgBilling ||
        props.isCreatingOrgBilling ||
        props.isDeletingOrgBilling ||
        props.isCreatingOrgBillingUsage ||
        props.isUpdatingOrgBilling) && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}
      {props.createOrgBillingUsageMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.createOrgBillingUsageMessage}
        </Alert>
      )}
      {props.updateOrgBillingMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.updateOrgBillingMessage}
        </Alert>
      )}
      {props.deleteOrgBillingMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.deleteOrgBillingMessage}
        </Alert>
      )}
      {props.createOrgBillingMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.createOrgBillingMessage}
        </Alert>
      )}
      {props.getOrgBillingMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.getOrgBillingMessage}
        </Alert>
      )}
      {/* {props.updateOrgBillingError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while updating orgBilling.
          {JSON.stringify(props.updateOrgBillingError.message)}
        </Alert>
      )} */}
      {props.deleteOrgBillingError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while deleting orgBilling.
          {JSON.stringify(props.deleteOrgBillingError.message)}
        </Alert>
      )}

      {props.getOrgBillingError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting orgBilling.
          {JSON.stringify(props.getOrgBillingError.message)}
        </Alert>
      )}
      {props.createOrgBillingUsageError && (
        <Alert className="mt-3 mb-0" color="success">
          {props.createOrgBillingUsageError}
        </Alert>
      )}

      {/* Data grid/table to display organization accounts */}
      {props.orgBilling && (
        // <div style={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={props.orgBilling}
          columns={columns}
          pageSize={5}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          autoHeight
          getRowId={(row) => row.billingId}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          initialState={{
            pagination: {
              paginationModel: { pageSize: 15, page: 0 },
            },
          }}
          density="compact"
        />
        // </div>
      )}

      {updateDialogOpen && (
        <UpdateOrganizationBilling
          open={updateDialogOpen}
          onClose={() => setUpdateDialogOpen(false)}
          updateOrgBillingRecord={props.orgBilling?.find(
            (billingRecord) => billingRecord.billingId === updateBillingId
          )}
          orgCode={orgCode}
        />
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="delete-confirmation-modal"
        aria-describedby="confirm-delete-orgBilling"
      >
        <div className={classes.deleteModal}>
          <h2 id="delete-confirmation-modal">Confirm Delete</h2>
          <p id="confirm-delete-orgBilling">
            Are you sure you want to delete this Organization Billing?
          </p>
          <div className={classes.modalButtons}>
            <Button onClick={handleDeleteConfirm} color="secondary">
              Delete
            </Button>
            <Button onClick={closeDeleteModal} color="primary">
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      {/* Aprove Confirmation Modal */}
      <Modal
        open={showApproveModal}
        onClose={closeApproveModal}
        aria-labelledby="delete-confirmation-modal"
        aria-describedby="confirm-delete-orgBilling"
      >
        <div className={classes.deleteModal}>
          <h2 id="delete-confirmation-modal">Approve Billing Record</h2>
          {props.updateOrgBillingError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while updating orgBilling.
              {JSON.stringify(props.updateOrgBillingError.message)}
            </Alert>
          )}
          <p id="confirm-delete-orgBilling">
            Are you sure you want to approve this Billing record?
          </p>
          <div className={classes.modalButtons}>
            <Button onClick={handleApproveConfirm} color="secondary">
              Approve
            </Button>
            <Button onClick={closeApproveModal} color="primary">
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      {/* Add Confirmation Modal */}
      <Modal
        open={showAddModal}
        onClose={closeAddModal}
        aria-labelledby="add-confirmation-modal"
        aria-describedby="confirm-add-orgBilling"
      >
        <div className={classes.deleteModal}>
          <h2 id="add-confirmation-modal">Post usage to AWS</h2>
          {props.createOrgBillingError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while creating orgBilling.
              {JSON.stringify(props.createOrgBillingError.message)}
            </Alert>
          )}
          <div className={classes.modalButtons}>
            <Button onClick={handleAddConfirm} color="secondary">
              POST
            </Button>
            <Button onClick={closeAddModal} color="primary">
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      {/* Modal to create Billing Usage */}
      {billingUsageModalOpen && (
        <OrganizationBillingUsage
          open={billingUsageModalOpen}
          onClose={handleBillingUsageModalClose}
          orgCode={orgCode}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    isGettingOrgBilling,
    getOrgBillingMessage,
    getOrgBillingError,
    orgBilling,

    isUpdatingOrgBilling,
    updateOrgBillingMessage,
    updateOrgBillingError,

    isCreatingOrgBilling,
    createOrgBillingMessage,
    createOrgBillingError,

    isDeletingOrgBilling,
    deleteOrgBillingMessage,
    deleteOrgBillingError,
  } = state.organizationBillingSlice;

  const {
    isCreatingOrgBillingUsage,
    createOrgBillingUsageMessage,
    createOrgBillingUsageError,
  } = state.organizationBillingUsageSlice;

  return {
    isGettingOrgBilling,
    getOrgBillingMessage,
    getOrgBillingError,
    orgBilling,

    isUpdatingOrgBilling,
    updateOrgBillingMessage,
    updateOrgBillingError,

    isCreatingOrgBilling,
    createOrgBillingMessage,
    createOrgBillingError,

    isDeletingOrgBilling,
    deleteOrgBillingMessage,
    deleteOrgBillingError,

    isCreatingOrgBillingUsage,
    createOrgBillingUsageMessage,
    createOrgBillingUsageError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgBilling: (orgCode) => {
      dispatch(getOrgBilling(orgCode));
    },
    updateOrgBilling: (updateOrgBillingPayload) => {
      dispatch(updateOrgBilling(updateOrgBillingPayload));
    },
    deleteOrgBilling: (deleteOrgBillingPayload) => {
      dispatch(deleteOrgBilling(deleteOrgBillingPayload));
    },
    createOrgBilling: (createOrgBillingPayload) => {
      dispatch(createOrgBilling(createOrgBillingPayload));
    },
    clearAllOrgBillingMessages: () => {
      dispatch(clearAllOrgBillingMessages());
    },
    clearAllOrgBillingUsageMessages: () => {
      dispatch(clearAllOrgBillingUsageMessages());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationBilling);
